import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col, Input, TreeSelect, Popconfirm } from 'antd';

import { IconDelete } from '../../../../data/assets/icons';
import { NLP_SERVICE_NAME } from '../../../../data/config/constants';

import './index.scss';

const TreeNode = TreeSelect.TreeNode;

export default class EntityEditor extends Component {
    renderTreeNode = () => {
        const { entities, nlpServiceName } = this.props;
        if (entities && nlpServiceName && entities.length > 0) {
            if (nlpServiceName === NLP_SERVICE_NAME.LUIS) {
                return (
                    entities.map((entity, index) => {
                        return (
                            <TreeNode key={index} title={entity.name} value={JSON.stringify({ type: entity.name })}>
                                {
                                    entity.children &&
                                    entity.children.map((entity_child, child_index) => {
                                        const value = { type: `${entity.name}::${entity_child.name}` };
                                        return (
                                            <TreeNode title={entity_child.name} key={`${entity_child.name}${child_index}`} value={JSON.stringify(value)} />
                                        );
                                    })
                                }
                            </TreeNode>
                        );
                    })
                );
            } else if (nlpServiceName === NLP_SERVICE_NAME.RASA) {
                return (
                    entities.map((entity, index) => {
                        return (
                            <TreeNode key={index} title={entity.name} value={entity.subLists && entity.subLists.length > 0 ? null : JSON.stringify({ entityID: entity.entityID, type: entity.name, subType: null })}>
                                {
                                    entity.subLists &&
                                    entity.subLists.map((entity_child, child_index) => {
                                        const value = {
                                            entityID: entity.entityID,
                                            type: entity.name,
                                            subType: entity_child.canonicalForm
                                        };
                                        return (
                                            <TreeNode title={entity_child.canonicalForm} key={`${entity_child.canonicalForm}${child_index}`} value={JSON.stringify(value)} />
                                        );
                                    })
                                }
                            </TreeNode>
                        );
                    })
                );
            } else {
                return (<TreeNode title="nlpServiceName is missing." />);
            }
        }
    };

    render() {
        const { container_class, selected_entity, index, updateEntityType, deleteEntity, size } = this.props;

        return (
            <div className={`ori-relative oriEntityEditorContainer ${container_class}`}>
                <Popconfirm placement="topLeft" title="Are you sure delete this Entity?" okText="Yes" cancelText="No" onConfirm={() => { deleteEntity(index); }}>
                    <div className="ori-absolute ori-animated ori-zoom-in ori-cursor-ptr ori-flex ori-pad-5 alignInsightDeleteIcon">
                        <IconDelete size={20} className={classNames("ori-font-light ")} />
                    </div>
                </Popconfirm>
                <Row className="ori-mobile-pad-5">
                    <Col xs={24} sm={8} className="ori-lr-pad-5 ori-b-pad-5" >
                        <TreeSelect size={size} showSearch className="ori-full-width ori-font-xs entityTreeSelect" placeholder="please select entity" dropdownClassName="entityDropdown" dropdownStyle={{ maxHeight: '40vh', overflow: 'auto' }} value={selected_entity.subType ? selected_entity.subType : selected_entity.type} onChange={(data) => data && updateEntityType(data, index)} >
                            {this.renderTreeNode()}
                        </TreeSelect>
                    </Col>
                    <Col xs={24} sm={16} className="ori-lr-pad-5 ori-b-pad-5">
                        <Input className="ori-full-width ori-font-xs ori-border-radius-1" size={size} value={selected_entity.entity} onChange={() => { }} />
                    </Col>
                </Row>
            </div>
        );
    }
}

EntityEditor.propTypes = {
    container_class: PropTypes.string,
    entities: PropTypes.array.isRequired,
    selected_entity: PropTypes.object,
    deleteEntity: PropTypes.func,
    updateEntityType: PropTypes.func,
    index: PropTypes.number,
    size: PropTypes.string,
    nlpServiceName: PropTypes.string,
};

EntityEditor.defaultProps = {
    size: 'small',
    container_class: 'ori-animated ori-fade-in '
};


// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/entityeditor/index.js